export const ratingItemWithLongText = {
    accommodationId: '1508918',
    foreignPartnerId: -1,
    date: '2024-09-02',
    staff: 10,
    cleanliness: 10,
    price: 10,
    convenience: 10,
    service: 10,
    restaurant: 0,
    approachability: 10,
    average: 10,
    positive:
        'Super kontakt. Miła właścicielka. Nowiuteńki budynek. Świetnie rozplanowany nowoczesny klimatyzowany apartament z wszystkim, co potrzeba na wyjazd. 8 minut spacerem z 3 dzieci do wejścia do Hungarospa. Miejsce parkingowe, grill, stół z krzesłami pod zadaszeniem. Nic więcej nie potrzeba. DZIĘKUJEMY!!!',
    negative: null,
    text: null,
    translatedText: null,
    content:
        'Super kontakt. Miła właścicielka. Nowiuteńki budynek. Świetnie rozplanowany nowoczesny klimatyzowany apartament z wszystkim, co potrzeba na wyjazd. 8 minut spacerem z 3 dzieci do wejścia do Hungarospa. Miejsce parkingowe, grill, stół z krzesłami pod zadaszeniem. Nic więcej nie potrzeba. DZIĘKUJEMY!!! Super kontakt. Miła właścicielka. Nowiuteńki budynek. Świetnie rozplanowany nowoczesny klimatyzowany apartament z wszystkim, co potrzeba na wyjazd. 8 minut spacerem z 3 dzieci do wejścia do Hungarospa. Miejsce parkingowe, grill, stół z krzesłami pod zadaszeniem. Nic więcej nie potrzeba. DZIĘKUJEMY!!!',
    hotelAnswer: 'Thank You very much!',
    stayNights: 2,
    guest: {
        name: 'Tomasz Kociuba',
        settlement: 'Sanok',
        category: {
            name: 'Rodzina z większym dzieckiem',
            type: 'FamilyWithOlderChildren',
        },
    },
    language: {
        code: 'pl',
        name: 'Polski',
    },
    updatedAt: '2025-09-16T10:47:42+00:00',
    roomId: 5083555,
};

export const ratingItemWithTranslation = {
    accommodationId: '1508918',
    foreignPartnerId: -1,
    date: '2024-09-02',
    staff: 10,
    cleanliness: 10,
    price: 10,
    convenience: 10,
    service: 10,
    restaurant: 0,
    approachability: 10,
    average: 10,
    positive:
        'Super kontakt. Miła właścicielka. Nowiuteńki budynek. Świetnie rozplanowany nowoczesny klimatyzowany apartament z wszystkim, co potrzeba na wyjazd. 8 minut spacerem z 3 dzieci do wejścia do Hungarospa. Miejsce parkingowe, grill, stół z krzesłami pod zadaszeniem. Nic więcej nie potrzeba. DZIĘKUJEMY!!!',
    negative: null,
    text: null,
    translatedText: null,
    content: 'Original text',
    translatedContent: 'Translated text',
    hotelAnswer: 'Thank You very much!',
    stayNights: 2,
    guest: {
        name: 'Tomasz Kociuba',
        settlement: 'Sanok',
        category: {
            name: 'Rodzina z większym dzieckiem',
            type: 'FamilyWithOlderChildren',
        },
    },
    language: {
        code: 'pl',
        name: 'Polski',
    },
    updatedAt: '2025-09-16T10:47:42+00:00',
    roomId: 5083555,
};

export const ratingItemNoGuestName = {
    accommodationId: '1508918',
    foreignPartnerId: -1,
    date: '2025-08-13',
    staff: 10,
    cleanliness: 10,
    price: 10,
    convenience: 10,
    service: 10,
    restaurant: 0,
    approachability: 10,
    average: 10,
    positive:
        'Bardzo ładny obiekt.Blisko do wejść na baseny.Wlascicielka  bardzo miła i pomocna . Bardzo udany wypoczynek następnym razem też tu będę się lokował .P O L E C A M!',
    negative: null,
    text: null,
    translatedText: null,
    translatedContent: null,
    content:
        'Bardzo ładny obiekt.Blisko do wejść na baseny.Wlascicielka  bardzo miła i pomocna . Bardzo udany wypoczynek następnym razem też tu będę się lokował .P O L E C A M!',
    hotelAnswer: 'Thank you very much!',
    stayNights: 3,
    guest: {
        name: null,
        settlement: null,
        category: {
            name: 'Rodzina z większym dzieckiem',
            type: 'FamilyWithOlderChildren',
        },
    },
    language: {
        code: 'pl',
        name: 'Polski',
    },
    updatedAt: '2025-09-16T10:47:42+00:00',
    roomId: 5088522,
};

export const ratingItems = [
    ratingItemWithLongText,
    ratingItemWithTranslation,
    ratingItemNoGuestName,
];
